import { render, staticRenderFns } from "./AtendimentoRoute.vue?vue&type=template&id=0bc486c2"
import script from "./AtendimentoRoute.vue?vue&type=script&lang=js"
export * from "./AtendimentoRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports